/**
 * Tax – Clients (add client)
 */

export default {
  addClient: {
    companyName: "Company Name",
    address: "Address",
    companyEmail: "Company's E-mail",
    phone: "Phone",
    phoneMust: 'The phone number must start with "+" and consist of digits',
    vatNum: "VAT number",
    postcode: "Postcode",
    country: "Country",
    cityTown: "City/Town",
    strAddress: "Street Address",
    housenum: "House number",
    apt: "Apartment",
    chooseFile: "Choose file",
    name: "Name",
    surname: "Surname",
    addUser: "Add user",
    email: "Email",
    password: "Password",
    cancel: "Cancel",
    err: {
      pass: "Please enter password",
      passLeast: "Your password must be at least 7 characters",
      emailInvalid: "Invalid email",
    },
  },
};
